export default "__VITE_ASSET__Dj1sd3uS__"